(() => {
  const sections = Array.from(document.querySelectorAll('.elx-hcg--tankless .elx-hcg__compare'));
  if (!sections.length) return;

  sections.forEach((section) => {
    section.setAttribute('data-elx-compare-motion', '');
    const cells = Array.from(section.querySelectorAll('[data-elx-compare-column]'));
    const setActiveColumn = (index) => {
      cells.forEach((cell) => {
        cell.classList.toggle('is-column-active', cell.dataset.elxCompareColumn === String(index));
      });
    };
    const clearActiveColumn = () => cells.forEach((cell) => cell.classList.remove('is-column-active'));

    cells.forEach((cell) => {
      const index = cell.dataset.elxCompareColumn;
      cell.addEventListener('pointerenter', () => setActiveColumn(index));
      cell.addEventListener('focusin', () => setActiveColumn(index));
      cell.addEventListener('pointerleave', clearActiveColumn);
      cell.addEventListener('focusout', () => {
        if (!section.contains(document.activeElement)) clearActiveColumn();
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      }, { threshold: 0.18 });
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();
